import type { Environment } from './environment.types';

export const environment: Environment = {
  production: false,
  type: 'dev',
  config: {
    API_BASE_URL: 'https://huubapp-service-cdt.maersk.io',
    ECL_PLATFORM_URL: 'https://mec-platform-dev.maersk.io',
  },
};
